import {
  IExtformDocument,
  IHref,
  IHrefList,
  ILogonDocument,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { CopyrightData } from '../model/copyright-data.interface';

/**
 * Check on exist copyright link in links
 *
 * @param links
 */
function copyrightLinkExist(links: IHrefList[]): boolean {
  return (
    links.findIndex(link => Object.keys(link).includes('copyright')) !== -1
  );
}

/**
 * Get data for copyright component from login/extform doc
 *
 * @param doc - Doc for login/extform page
 */
export function mapDocToCopyrightData(
  doc?: IExtformDocument | ILogonDocument,
): CopyrightData | null {
  if (!doc) {
    return null;
  }

  const links = DocHelper.getArrayWrapperValue(doc.links);
  if (!copyrightLinkExist(links)) {
    return null;
  }

  const linkWithCopyright = links.find(linkObject => {
    const linkNames = Object.keys(linkObject);
    return linkNames.includes('copyright');
  });

  if (!linkWithCopyright) {
    return null;
  }

  const copyright = linkWithCopyright.copyright as IHref;
  return {
    text: copyright.$,
    href: copyright.$href,
  };
}
